'use client'

import { m } from 'framer-motion'
import { ArrowRight } from 'lucide-react'

import AnimatedCounter from '@/components/AnimatedCounter'

export default function AgencyManifesto() {
  return (
    <section className="relative overflow-hidden py-24 sm:py-32">
      <div className="home-container relative z-10">
        <div className="mb-16 text-center">
          <m.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5"
          >
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-blue-400" />
            <span className="home-meta text-gray-400">Наша философия</span>
          </m.div>
        </div>

        <div className="flex flex-col items-end gap-20 lg:flex-row">
          <div className="lg:w-1/2">
            <m.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="home-card-title-premium mb-10 text-white"
            >
              Цифровой <br />
              <i className="font-light text-gray-400">Горизонт.</i>
            </m.h2>

            <m.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="rounded-[40px] border border-white/5 bg-white/[0.03] p-8 backdrop-blur-sm sm:p-10"
            >
              <p className="home-lead mb-6 text-gray-200">Мы превращаем идеи в цифровые активы.</p>
              <p className="home-subnote leading-relaxed text-gray-400">
                Наш подход прост: глубокое погружение, безупречное исполнение. Мы не продаем процесс
                ради процесса. Мы создаем инструменты, которые приносят деньги и выглядят как
                искусство.
              </p>

              <div className="group mt-8 flex w-fit cursor-pointer items-center gap-4 font-medium text-white">
                <span className="home-subnote text-white">Узнать наши принципы</span>
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-black transition-transform group-hover:scale-110">
                  <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </m.div>
          </div>

          <div className="flex flex-col gap-10 lg:w-1/2">
            <m.p
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="home-lead leading-snug text-gray-300"
            >
              В мире шума мы создаем тишину, в которой слышен голос вашего бренда. Цифровой горизонт
              — это эстетика технологий.
            </m.p>

            <m.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="grid grid-cols-2 gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10"
            >
              {[
                { val: 10, label: 'Лет опыта' },
                { val: 20, label: 'Реализованных проектов' },
                { val: 20, label: 'Активных клиентов' },
                { val: 100, label: 'Успешных кейсов' },
              ].map((stat, i) => (
                <div
                  key={i}
                  className="bg-[#0a0f18]/80 p-6 backdrop-blur-md transition-colors hover:bg-[#0a0f18] sm:p-8"
                >
                  <AnimatedCounter
                    value={stat.val}
                    suffix={i === 3 ? '%' : '+'}
                    className="mb-2 [&>p]:text-[2.15rem] [&>p]:leading-none [&>p]:font-semibold [&>p]:whitespace-nowrap sm:[&>p]:text-4xl"
                  />
                  <div className="home-meta leading-relaxed text-gray-500">{stat.label}</div>
                </div>
              ))}
            </m.div>
          </div>
        </div>
      </div>
    </section>
  )
}
